export const profileColors: string[] = [
  '#8BC34A',
  '#2196F3',
  '#E33700',
  '#F8558C',
  '#FFEB3B',
  '#673AB7',
  '#00BCD4',
  '#009688',
  '#FF9800',
];
